<template>
  <vx-card class="min-h-screen">
    <ResponseAlert ref="response" />
    <vs-table
      :sst="true"
      @sort="sort"
      :data="config.rows"
      style="white-space: nowrap"
    >
      <template slot="header">
        <vs-row>
          <vs-col
            class="mt-5"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <vs-row class="justify-between" vs-type="flex" vs-w="12">
              <vs-col vs-lg="4" vs-sm="12" vs-xs="12">
                <vs-button
                  v-for="type in masters.types"
                  :key="type.value"
                  class="rounded-sm"
                  :class="{
                    'text-primary':
                      type.value !== config.additional_params.birthday,
                  }"
                  :color="
                    type.value === config.additional_params.birthday
                      ? 'primary'
                      : '#fff'
                  "
                  type="filled"
                  @click="config.additional_params.birthday = type.value"
                  >{{ type.text }}
                </vs-button>
              </vs-col>
              <vs-col vs-lg="3" vs-sm="12" vs-xs="12">
                <vs-button
                  @click="bulkApproveEmail"
                  class="rounded-sm w-full"
                  :disabled="selectedItems.length === 0"
                  color="success"
                  type="filled"
                >
                  Bulk Approval Change Email ({{ selectedItems.length }})
                </vs-button>
              </vs-col>
              <vs-col class="md:mt-0" vs-lg="5" vs-sm="12" vs-xs="12">
                <vs-row
                  class="mb-5 mt-5 lg:mt-0"
                  vs-type="flex"
                  vs-justify="space-around"
                  vs-w="12"
                >
                  <vs-col class="relative" vs-lg="5" vs-md="4" vs-xs="12">
                    <i
                      class="vs-icon notranslate icon-scale material-icons null absolute z-50"
                      style="top: 12px; right: 10px"
                      >search</i
                    >
                    <vs-input
                      class="w-full"
                      placeholder="Search"
                      v-model="config.search"
                      @input="handleSearch"
                    />
                  </vs-col>
                  <vs-col
                    class="mt-5 md:mt-0 px-0 md:px-2"
                    vs-lg="4"
                    vs-md="6"
                    vs-xs="12"
                  >
                    <vs-button
                      @click="models.advance_search = true"
                      class="w-full"
                      color="primary"
                      type="filled"
                      >Advance Search</vs-button
                    >
                  </vs-col>
                  <vs-col class="mt-3 md:mt-0" vs-lg="3" vs-md="6" vs-xs="12">
                    <vs-button
                      @click="exportExcel"
                      class="w-full"
                      color="primary"
                      type="filled"
                      >Export</vs-button
                    >
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </template>
      <template slot="thead">
        <vs-th width="5%" class="text-center">
          <input
            type="checkbox"
            @change="toggleCheckAll"
            :checked="isAllChecked"
          />
        </vs-th>
        <vs-th
          :sort-key="row.value"
          v-for="(row, key) in config.headers"
          :key="key"
          :width="row.width"
          :class="row.class"
        >
          {{ row.title }}
        </vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="text-center" width="5%">
            <input
              type="checkbox"
              :value="parseInt(data[indextr].id)"
              v-model.number="selectedItems"
            />
          </vs-td>
          <vs-td :data="data[indextr].name">
            {{ data[indextr].name }}
          </vs-td>
          <vs-td :data="tierName(data[indextr])">
            {{ tierName(data[indextr]) || "-" }}
          </vs-td>
          <vs-td :data="data[indextr].community">
            {{
              data[indextr].community ? data[indextr].community.join(", ") : "-"
            }}
          </vs-td>

          <vs-td :data="data[indextr].followerIg">
            {{ data[indextr].followerIg }}
          </vs-td>

          <vs-td :data="data[indextr].followerTiktok">
            {{ data[indextr].followerTiktok }}
          </vs-td>

          <vs-td :data="data[indextr].province">
            {{ data[indextr].province }}
          </vs-td>

          <vs-td>
            <vs-chip :color="getBAStatusColor(data[indextr])">
              {{ getBAStatusText(data[indextr]) }}
            </vs-chip>
          </vs-td>

          <vs-td>
            <vs-chip :color="getRequestChangeEmailStatusColor(data[indextr])">
              {{ getRequestChangeEmailStatusText(data[indextr]) }}
            </vs-chip>
          </vs-td>

          <vs-td class="flex">
            <feather-icon
              v-if="data[indextr].statusRequestChangeEmail == 'waiting_approve'"
              @click="updateRequestEmailStatus(data[indextr], 'approve')"
              icon="CheckIcon"
              svgClasses="w-5 h-5 mr-3 stroke-current cursor-pointer"
            />
            <feather-icon
              v-if="data[indextr].statusRequestChangeEmail == 'waiting_approve'"
              @click="updateRequestEmailStatus(data[indextr], 'reject')"
              icon="XIcon"
              svgClasses="w-5 h-5 mr-3 stroke-current cursor-pointer"
            />

            <router-link
              :to="`/${config.uri}/${data[indextr].id}`"
              class="text-black"
              title="View"
            >
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5 mr-3 stroke-current cursor-pointer"
              />
            </router-link>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <Pagination :config="config" @gotoPage="gotoPage" />

    <vs-popup
      button-close-hidden
      title="Search"
      :active.sync="models.advance_search"
    >
      <vs-row>
        <vs-col vs-type="flex" class="flex-col pr-1" vs-w="6" vs-xs="12">
          <label class="mb-1">Follower Instagram</label>
          <vs-row>
            <vs-col vs-type="flex" vs-lg="6">
              <vs-input
                autocomplete="off"
                @keypress="checkValidationNumber"
                placeholder="Min"
                type="number"
                v-model="models.instagram.followers.min"
                class="w-full pr-1"
              />
            </vs-col>
            <vs-col vs-type="flex" vs-lg="6" class="flex flex-col">
              <vs-input
                autocomplete="off"
                v-validate="getValueProp('instagram.followers')"
                @keypress="checkValidationNumber"
                placeholder="Max"
                type="number"
                name="Max IG Followers"
                v-model="models.instagram.followers.max"
                class="w-full pl-1"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Max IG Followers')"
                >{{ errors.first("Max IG Followers") }}</span
              >
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col
          vs-type="flex"
          class="flex-col pl-1 mt-5 md:mt-0"
          vs-w="6"
          vs-xs="12"
        >
          <label class="mb-1">Engagement Instagram</label>
          <vs-row>
            <vs-col vs-type="flex" vs-lg="6">
              <vs-input
                autocomplete="off"
                @keypress="checkValidationNumber"
                placeholder="Min"
                type="number"
                v-model="models.instagram.engagement.min"
                class="w-full pr-1"
              />
            </vs-col>
            <vs-col vs-type="flex" vs-lg="6" class="flex flex-col">
              <vs-input
                autocomplete="off"
                v-validate="getValueProp('instagram.engagement')"
                @keypress="checkValidationNumber"
                placeholder="Max"
                name="Max IG Engagement"
                type="number"
                v-model="models.instagram.engagement.max"
                class="w-full pl-1"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Max IG Engagement')"
                >{{ errors.first("Max IG Engagement") }}</span
              >
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row class="mt-5">
        <vs-col vs-type="flex" class="flex-col pr-1" vs-w="6" vs-xs="12">
          <label class="mb-1">Follower Tiktok</label>
          <vs-row>
            <vs-col vs-type="flex" vs-lg="6">
              <vs-input
                autocomplete="off"
                @keypress="checkValidationNumber"
                placeholder="Min"
                type="number"
                v-model="models.tiktok.followers.min"
                class="w-full pr-1"
              />
            </vs-col>
            <vs-col vs-type="flex" vs-lg="6" class="flex flex-col">
              <vs-input
                autocomplete="off"
                v-validate="getValueProp('tiktok.followers')"
                @keypress="checkValidationNumber"
                placeholder="Max"
                type="number"
                name="Max Tiktok Followers"
                v-model="models.tiktok.followers.max"
                class="w-full pl-1"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Max Tiktok Followers')"
                >{{ errors.first("Max Tiktok Followers") }}</span
              >
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col
          vs-type="flex"
          class="flex-col pl-1 mt-5 md:mt-0"
          vs-w="6"
          vs-xs="12"
        >
          <label class="mb-1">Engagement Tiktok</label>
          <vs-row>
            <vs-col vs-type="flex" vs-lg="6">
              <vs-input
                autocomplete="off"
                @keypress="checkValidationNumber"
                type="number"
                placeholder="Min"
                v-model="models.tiktok.engagement.min"
                class="w-full pr-1"
              />
            </vs-col>
            <vs-col vs-type="flex" vs-lg="6">
              <vs-input
                autocomplete="off"
                @keypress="checkValidationNumber"
                v-validate="getValueProp('tiktok.engagement')"
                placeholder="Max"
                type="number"
                name="Max Tiktok Engagement"
                v-model="models.tiktok.engagement.max"
                class="w-full pl-1"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Max Tiktok Engagement')"
                >{{ errors.first("Max Tiktok Engagement") }}</span
              >
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row class="mt-5">
        <vs-col vs-type="flex" class="flex-col pr-1" vs-w="6" vs-xs="12">
          <vs-row>
            <vs-col vs-type="flex" vs-lg="12" class="flex-col pl-1">
              <label class="mb-1">Tier</label>
              <select class="w-full" v-model="config.additional_params.tierId">
                <option
                  v-for="(tier, index) in masters.tiers"
                  :key="index"
                  :value="tier.id"
                >
                  {{ tier.name }}
                </option>
              </select>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col
          vs-type="flex"
          class="flex-col pl-1 mt-5 md:mt-0"
          vs-w="6"
          vs-xs="12"
        >
          <vs-row>
            <vs-col vs-type="flex" vs-lg="6" class="flex-col pr-1">
              <label class="mb-1">Skin Type</label>
              <select
                class="w-full"
                v-model="config.additional_params.skinTypeId"
              >
                <option
                  v-for="(type, index) in masters.skinTypes"
                  :key="index"
                  :value="type.id"
                >
                  {{ type.name }}
                </option>
              </select>
            </vs-col>
            <vs-col vs-type="flex" vs-lg="6" class="flex-col pl-1">
              <label class="mb-1">Skin Concern</label>
              <select
                class="w-full"
                v-model="config.additional_params.skinConcernId"
              >
                <option
                  v-for="(val, index) in masters.skinConcerns"
                  :key="index"
                  :value="val.id"
                >
                  {{ val.name }}
                </option>
              </select>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row class="mt-5">
        <vs-col vs-type="flex" class="flex-col pr-1" vs-w="8" vs-xs="12">
          <vs-row>
            <vs-col vs-type="flex" vs-lg="4" class="pr-1">
              <vs-button class="w-full" color="success" @click="advanceSearch"
                >Submit</vs-button
              >
            </vs-col>
            <vs-col vs-type="flex" vs-lg="4" class="pr-1">
              <vs-button class="w-full" color="warning" @click="resetSearch"
                >Reset</vs-button
              >
            </vs-col>
            <vs-col vs-type="flex" vs-lg="4" class="pl-1">
              <vs-button
                @click="models.advance_search = false"
                class="w-full"
                color="danger"
                >Cancel</vs-button
              >
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-popup>
  </vx-card>
</template>

<script>
import moment from "moment";
import { getColorStatus, checkValidationNumber } from "@/utils/helpers";
import api from "@/utils/api";
export default {
  name: "ListAmbassadors",
  data() {
    return {
      selectedItems: [],
      checkValidationNumber,
      config: {
        uri: this.$route.meta.link,
        api: api.brandAmbasador,
        rows: [],
        total_data: 0,
        total_page: 0,
        per_page: 10,
        page: 1,
        orderby: "id",
        sort: "desc",
        search: "",
        additional_params: {
          birthday: null,
          skinTypeId: null,
          skinConcernId: null,
          tierId: null,
          followerIg: null,
          engagementIg: null,
          followerTiktok: null,
          engagementTiktok: null,
        },
        debounce: null,
        headers: [
          {
            title: "Name",
            value: "name",
            align: "text-left",
            width: "25%",
          },
          {
            title: "Tier",
            value: "tier",
            align: "text-left",
            width: "15%",
          },
          {
            title: "Community",
            value: "community",
            align: "text-left",
            width: "20%",
          },
          {
            title: "Instagram",
            value: "followerIg",
            align: "text-left",
            width: "10%",
          },
          {
            title: "Tiktok",
            value: "followerTiktok",
            align: "text-left",
            width: "10%",
          },
          {
            title: "City/Domicile",
            value: "province",
            align: "text-left",
            width: "15%",
          },
          {
            title: "Status",
            value: "",
            align: "text-left",
            width: "25%",
          },
          {
            title: "Request Change Email",
            value: "",
            align: "text-left",
            width: "25%",
          },
          {
            title: "Action",
            value: "",
            class: "text-center",
            width: "10%",
          },
        ],
      },
      models: {
        advance_search: false,
        search: "",

        instagram: {
          followers: {
            min: null,
            max: null,
          },
          engagement: {
            min: null,
            max: null,
          },
        },
        tiktok: {
          followers: {
            min: null,
            max: null,
          },
          engagement: {
            min: null,
            max: null,
          },
        },

        skinTypeId: null,
        skinConcernId: null,
      },
      masters: {
        types: [
          {
            text: "All",
            value: null,
          },
          {
            text: "Today Birthday",
            value: true,
          },
        ],
        statuses: [
          { value: null, text: "Status" },
          { value: false, text: "Active" },
          { value: true, text: "Inactive" },
        ],
        tiers: [{ id: null, name: "All Tiers" }],
        skinTypes: [{ id: null, name: "All Skin Types" }],
        skinConcerns: [{ id: null, name: "All Skin Concerns" }],
      },
      moment,
      getColorStatus,
    };
  },
  computed: {
    paramsChange() {
      return `${this.config.additional_params.birthday}`;
    },
    isAllChecked() {
      return (
        this.config.rows.length > 0 &&
        this.selectedItems.length === this.config.rows.length
      );
    },
  },
  created() {
    const _ = this;
    _.get();
    _.getMasterOptions();
  },
  watch: {
    "config.per_page"() {
      this.config.page = 1;
      this.get();
    },
  },
  methods: {
    tierName(row) {
      if (!row) return "";

      if (row.tier && row.tier.name) {
        return row.tier.name;
      }

      const tierId = row.tierId || row.tier_id;
      const tier = this.masters.tiers.find((tier) => tier.id === tierId);

      return row.tierName || row.tier_name || (tier && tier.name) || "";
    },
    toggleCheckAll(event) {
      if (event.target.checked) {
        this.selectedItems = this.config.rows.map((row) => parseInt(row.id));
      } else {
        this.selectedItems = [];
      }
    },
    bulkApproveEmail() {
      console.log("Selected Items:", this.selectedItems);
      if (this.selectedItems.length === 0) {
        this.$refs.response.setResponseCustom(
          "Please select at least one user",
          "warning"
        );
        return;
      }

      const confirmed = confirm(
        `Are you sure you want to approve email change for ${this.selectedItems.length} user(s)?`
      );
      if (confirmed) {
        console.log("User confirmed, submitting bulk approval");
        this.submitBulkApproval();
      } else {
        console.log("User cancelled");
      }
    },
    submitBulkApproval() {
      console.log("Submitting bulk approval with IDs:", this.selectedItems);
      const payload = {
        userIds: this.selectedItems,
      };
      console.log("Payload:", payload);

      this.$axios
        .patch(`${api.brandAmbasador}/bulk-approve-email`, payload)
        .then((res) => {
          console.log("Bulk approval success:", res.data);
          this.$refs.response.setResponseCustom(
            res.data.message || "Bulk approval successful",
            "success"
          );
          this.selectedItems = [];
          // Reset pagination ke halaman 1
          this.config.page = 1;
          this.config.search = "";
          sessionStorage.removeItem("db_currentPage");
          // Reload data
          this.get();
        })
        .catch((err) => {
          console.log("Bulk approval error:", err);
          const errorMessage =
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : "Error occurred";
          this.$refs.response.setResponseCustom(errorMessage, "danger");
        });
    },
    updateRequestEmailStatus(data, status) {
      // Endpoint: [PUT] /brand-ambasador/:id/email-status
      const params = {
        status: status,
      };

      this.$axios
        .put(`${api.brandAmbasador}/${data.id}/email-status`, params)
        .then((res) => {
          this.$response.success(res.data.message);
        })
        .catch((err) => {
          this.$response.error(err.response.data.message);
        })
        .finally(() => {
          this.get();
        });
    },
    get() {
      console.log("Getting data with config:", this.config);
      const pagination = JSON.parse(sessionStorage.getItem("db_currentPage"));
      if (pagination && pagination.route === "brand-ambassador") {
        this.config.page = pagination.page;
      }
      this.$table
        .get(this.config)
        .then(() => {
          console.log("Data loaded successfully");
          this.$watch("paramsChange", () => {
            this.get();
          });
        })
        .catch((err) => {
          console.log("Error loading data:", err);
        });
    },
    advanceSearch() {
      this.$validator.validate().then(async (valid) => {
        if (valid) {
          this.models.advance_search = false;

          const platforms = ["instagram", "tiktok"];
          const types = ["followers", "engagement"];

          platforms.forEach((platform) => {
            types.forEach((type) => {
              if (this.models[platform][type].min) {
                let params = "";
                switch (`${platform}.${type}`) {
                  case "instagram.followers":
                    params = "followerIg";
                    break;
                  case "instagram.engagement":
                    params = "engagementIg";
                    break;
                  case "tiktok.followers":
                    params = "followerTiktok";
                    break;
                  case "tiktok.engagement":
                    params = "engagementTiktok";
                    break;
                  default:
                    break;
                }
                this.config.additional_params[
                  params
                ] = `${this.models[platform][type].min},${this.models[platform][type].max}`;
              }
            });
          });

          this.get();
        }
      });
    },
    getMasterOptions() {
      const getTiers = this.$axios.get(api.mics_tiers);
      const getSkinTypes = this.$axios.get(api.misc_skinTypes);
      const getSkinConcerns = this.$axios.get(api.misc_skinConcerns);

      Promise.all([getTiers, getSkinTypes, getSkinConcerns]).then((res) => {
        const masters = ["tiers", "skinTypes", "skinConcerns"];
        masters.forEach((master, index) => {
          res[index].data.data.forEach((res) => {
            this.masters[master].push({
              id: res.id,
              name: res.name,
            });
          });
        });
      });
    },
    sort(orderby) {
      if (orderby !== "") this.$table.sort(this.config, orderby);
    },
    gotoPage(page) {
      sessionStorage.setItem(
        "db_currentPage",
        JSON.stringify({
          route: "brand-ambassador",
          page,
        })
      );
      this.$table.gotoPage(this.config, page);
    },
    handleSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        sessionStorage.setItem("db_currentPage", 1);
        this.config.page = 1;
        this.get();
      }, 500);
    },
    exportExcel() {
      const config = this.config;
      const additional_params = config.additional_params || {};
      const search = { search: config.search };
      this.$axios
        .get(api.exportBAExcel, {
          params: Object.assign(search, additional_params),
          responseType: "blob",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          });
          const aEle = document.createElement("a"); // Create a label
          const href = window.URL.createObjectURL(blob); // Create downloaded link
          aEle.href = href;
          aEle.download = `Report Brand Ambassador (${moment().format(
            "DD MMMM YYYY"
          )})`; // File name after download
          document.body.appendChild(aEle);
          aEle.click(); // Click to download
          document.body.removeChild(aEle); // Download complete remove element
          window.URL.revokeObjectURL(href); // Release blob object
        });
    },
    getValueProp(data) {
      const models = data.split(".");
      return this.models[models[0]][models[1]].min
        ? `required|min_value:${this.models[models[0]][models[1]].min}`
        : "";
    },
    resetSearch() {
      const params = [
        "skinTypeId",
        "skinConcernId",
        "tierId",
        "followerIg",
        "engagementIg",
        "followerTiktok",
        "engagementTiktok",
      ];
      params.forEach((param) => {
        this.config.additional_params[param] = null;
      });
      this.models.advance_search = false;

      const platforms = ["instagram", "tiktok"];
      const types = ["followers", "engagement"];

      platforms.forEach((platform) => {
        types.forEach((type) => {
          this.models[platform][type].min = null;
          this.models[platform][type].max = null;
        });
      });

      this.get();
    },
    getBAStatusText(user) {
      // issVerified === false || isBanned || isSuspend ? 'text-danger' : isVerified === true ? 'text-success' : 'text-warning'
      return user.isSuspend
        ? "Suspend"
        : user.isBanned
        ? "Banned"
        : user.isVerified === true
        ? "Approved"
        : user.isVerified === false
        ? "Rejected"
        : "Waiting Approval";
    },
    getBAStatusColor(user) {
      return user.isVerified === false || user.isBanned || user.isSuspend
        ? "danger"
        : user.isVerified === true
        ? "success"
        : "warning";
    },
    getRequestChangeEmailStatusText(user) {
      let text = "-";

      switch (user.statusRequestChangeEmail) {
        case "waiting_approve":
          text = "Waiting Approval";
          break;
        case "approve":
          text = "Approved";
          break;
        case "reject":
          text = "Rejected";
          break;
        default:
          text = "-";
          break;
      }
      return text;
    },
    getRequestChangeEmailStatusColor(user) {
      // return user.statusRequestChangeEmail === null? null : user.isVerified === true ? 'success' : 'warning'
      switch (user.statusRequestChangeEmail) {
        case "waiting_approve":
          return "warning";
        case "approve":
          return "success";
        case "reject":
          return "danger";
        default:
          return null;
      }
    },
  },
};
</script>

<style></style>
